module.exports = __webpack_public_path__ + "img/section2-boxImg3.1d969165.png";